import React from 'react';

// Loads the catalog (idempotent, retryable) alongside a route chunk. The dynamic
// import keeps @ergeon/erg-catalog-rules — and with it the whole @ergeon chunk —
// out of the entry bundle, so the auth gate paints before any catalog bytes move.
export const startCatalogLoad = (): Promise<unknown> =>
  import('@ergeon/erg-catalog-rules').then(({initCatalog}) => initCatalog());

// Drop-in replacement for React.lazy for routes that read catalog data: the chunk
// download and the catalog load run in parallel, and the route only renders once
// both are ready. A failed catalog load rejects the lazy component (surfaced by the
// route ErrorBoundary); remounting retries via initCatalog's retry semantics.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const lazyWithCatalog = <T extends React.ComponentType<any>>(
  load: () => Promise<{default: T}>
): React.LazyExoticComponent<T> =>
    React.lazy(() => Promise.all([load(), startCatalogLoad()]).then(([module]) => module));

export default lazyWithCatalog;
